const SITE_URL = 'https://coursepress.lnu.se'
const PATH_PREFIX = '/kurser/webbprogrammering-pa-serversidan'

const config = {
  gatsby: {
    pathPrefix: PATH_PREFIX,
    siteUrl: SITE_URL,
    gaTrackingId: null
  },
  header: {
    logoLink: '/',
    title: 'logo-wordmark-sv.png',
    courseName: 'Webbprogrammering på serversidan (1DV026)',
    links: [
      { text: 'GitLab', link: 'https://gitlab.lnu.se/1dv026' },
      { text: 'Zoom', link: `${SITE_URL}${PATH_PREFIX}/zoom` },
      { text: 'Moodle', link: 'https://moodle.lnu.se/course/view.php?id=63359'},
      { text: 'YouTube', link: 'https://www.youtube.com/cslnu' },
      { text: 'Schema', link: 'https://cloud.timeedit.net/lnu/web/schema2/ri16YXQ5769Z58Qv550191Z6yQY550069Y5365gQ007Y757ZqyZXQhqcc0bpyowcbQnQZcdmnZQ.html'}
    ]
  },
  sidebar: {
    frontline: false,
    ignoreIndex: true,
    startCollapsed: true
  },
  siteMetadata: {
    title: 'Linnéuniversitetet',
    language: "sv",
    description: 'Documentation built with mdx. Powering learn.hasura.io ',
    ogImage: null
  }
}

module.exports = config
